import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import 'contents/assets/scss/page/student.scss';

function SatisfactionExternal() {
  const [modalOpen, setModalOpen] = useState(true);
  return (
    <main className="com_container">
      <Modal open={modalOpen} close={() => setModalOpen(false)} type="pop_class_request">
        <h2 className="pop_tit">수업진행 요청서</h2>
        <button type="button" className="btn_close"></button>
        <div className="content_container scroll">
				{/* 20250218 퍼블 추가 & 수정(명칭및내용전체변경 */}
          <div className="com_board_box">
            <div className="board_item">
              <div className="info">
                <p className="cont bold">요청 수업</p>
              </div>
              <div className="info">
                <span className="tit">학생명</span>
                <p className="cont com_blue_txt">
                  <b>김학생</b>(고3이상)
                </p>
              </div>
              <div className="info">
                <span className="tit">학교명</span>
                <p className="cont com_blue_txt">OOO고등학교</p>
              </div>
              <div className="info">
                <span className="tit">수업지역</span>
                <p className="cont com_blue_txt">경기도 성남시 분당구 백형동 3214-345</p>
              </div>
              <div className="info">
                <span className="tit">수업 과목</span>
                <p className="cont com_blue_txt">과탐(사회문화, 경제, 밥과정서)</p>
              </div>
              <div className="info">
                <span className="tit">가능 수업일,시간 </span>
                <p className="cont com_blue_txt">월, 화 ㅣ 12 : 30</p>
              </div>
              <div className="info">
                <span className="tit">완성수업 유/무</span>
                <p className="cont"></p>
              </div>
              <div className="info">
                <span className="tit">수업 시간 / 방법</span>
                <p className="cont com_blue_txt">30분 / 대면</p>
              </div>
              <div className="info">
                <span className="tit">동시수업</span>
                <p className="cont com_blue_txt">김학생103, 최학생123, 최학생105,</p>
              </div>
              <div className="info">
                <span className="tit">수업일</span>
                <p className="cont com_blue_txt">2023, 05, 12 ㅣ 12 : 30</p>
              </div>
            </div>
          </div>
          <div className="com_board_box">
            <div className="com_info center">
              <p className="name">요청일 : 2024, 05, 12 ㅣ 12 : 30</p>
            </div>
          </div>
          <div className="com_radio_wrap center">
            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
            <label htmlFor="rdo01">수업 승인</label>
            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
            <label htmlFor="rdo02">수업불가</label>
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확 인</button>
        </div>
      </Modal>
    </main>
  );
}

export default SatisfactionExternal;
